export const statusActions = [
    'new',
    'accepted'
];